import PropTypes from 'prop-types';
import classNames from 'classnames';
import './NavigationSide.scss';

function NavigationSide({
  className = '',
  testId,
  children,
}) {
  return (
    <div
      className={classNames('NavigationSide', className)}
      data-testid={testId}
    >
      {children}
    </div>
  );
}

NavigationSide.propTypes = {
  className: PropTypes.string,
  /** data-testid attribute for E2E test selectors */
  testId: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default NavigationSide;
